import React from 'react'
import { useParams } from 'react-router'
import { editSign } from '../../api/branchesRequests'
import Home from './Home'
export default function EditSignature() {

    const {id} = useParams()
    return (
        <div>
            <Home canGoNext={() => true} submitFunction={editSign} id={id}/>
        </div>
    )
}
